import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getActivityBridge } from '@/features/activityAssistant/activityAssistant.service';

/**
 * Keeps web and desktop logout behavior aligned wherever the user menu is
 * exposed, including the mobile More sheet.
 */
export function useLogout() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return useCallback(async () => {
    let deleteLocalActivityData = false;

    try {
      const status = await getActivityBridge().getStatus();
      if (status.environment !== 'web') {
        deleteLocalActivityData = window.confirm(
          'Delete this user’s local activity history and association rules after logout? Select Cancel to keep them on this device.',
        );
      }
    } catch {
      // Logout must still complete if the native bridge cannot be reached.
    } finally {
      try {
        await logout({ deleteLocalActivityData });
      } finally {
        navigate('/login');
      }
    }
  }, [logout, navigate]);
}
